<template lang="pug">

.navigation-container
  .navigation-content
    .nav-button.prev-button(@click="prevNext")
      v-icon.nav-icon mdi-chevron-left
      span.nav-text(v-if="!isTablet") Предыдущая неделя

    .date-section
      .date-icon
        v-icon(size="18" color="#64748b") mdi-calendar-month
      .date-text
        .date-range(v-if="!isMobile") {{ start }} - {{ end }}
        .date-single(v-else) {{ start }}

    .nav-button.next-button(@click="nextDate")
      span.nav-text(v-if="!isTablet") Следующая неделя
      v-icon.nav-icon mdi-chevron-right

</template>

<script>
import { mapMutations, mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'Navigations',

  computed: {
    ...mapState('navigations', ['date']),

    start() {
      return moment(this.date).format('DD.MM.YYYY')
    },

    end() {
      return moment(this.date).isoWeekday(7).format('DD.MM.YYYY')
    },

    isMobile() {
      return ['xs'].includes(this.$vuetify.breakpoint.name)
    },

    isTablet() {
      return ['xs', 'sm'].includes(this.$vuetify.breakpoint.name)
    },
  },

  methods: {
    ...mapMutations('navigations', ['updateDate']),

    prevNext() {
      this.updateDate(
        moment(this.start, 'DD.MM.YYYY').add(-7, 'day').format('YYYY-MM-DD')
      )
    },

    nextDate() {
      this.updateDate(
        moment(this.start, 'DD.MM.YYYY').add(7, 'day').format('YYYY-MM-DD')
      )
    },

    replaceQueryDate() {
      try {
        this.$router.replace({ query: { date: this.date }})
        // eslint-disable-next-line
      } catch { }
    }
  },

  mounted() {
    this.$watch(() => this.date, () => {
      this.replaceQueryDate()
    })
  }
}
</script>

<style lang="sass" scoped>

.navigation-container
  display: flex
  justify-content: center
  margin-bottom: 24px

.navigation-content
  display: flex
  align-items: center
  background: white
  border-radius: 12px
  box-shadow: 0 2px 8px rgba(0,0,0,0.1)
  border: 1px solid #e2e8f0
  padding: 8px
  gap: 0

.nav-button
  display: flex
  align-items: center
  padding: 12px 16px
  cursor: pointer
  transition: all 0.2s ease
  border-radius: 8px
  user-select: none
  min-height: 44px
  touch-action: manipulation
  -webkit-tap-highlight-color: transparent

  // Hover only for devices with mouse
  @media (hover: hover)
    &:hover
      background: #f1f5f9

  &:active
    background: #e2e8f0

.nav-icon
  color: #3b82f6
  font-size: 20px

.nav-text
  color: #1e293b
  font-weight: 500
  font-size: 14px
  white-space: nowrap

.prev-button
  .nav-text
    margin-left: 8px

.next-button
  .nav-text
    margin-right: 8px

.date-section
  display: flex
  align-items: center
  padding: 12px 24px
  flex: 1
  justify-content: center
  border-left: 1px solid #f1f5f9
  border-right: 1px solid #f1f5f9
  min-height: 44px

.date-icon
  margin-right: 12px

.date-text
  display: flex
  flex-direction: column
  align-items: center

.date-range, .date-single
  color: #334155
  font-weight: 600
  font-size: 15px
  line-height: 1.2

// Mobile and tablet styles
@media (max-width: 768px)
  .navigation-content
    padding: 6px
    gap: 4px

  .nav-button
    padding: 10px 12px
    min-height: 40px

  .date-section
    padding: 10px 16px
    min-height: 40px

  .date-icon
    margin-right: 8px

  .date-range, .date-single
    font-size: 14px

@media (max-width: 480px)
  .navigation-container
    margin-bottom: 16px

  .navigation-content
    padding: 4px
    border-radius: 8px

  .nav-button
    padding: 8px 10px
    min-height: 36px

  .nav-icon
    font-size: 18px

  .date-section
    padding: 8px 12px
    min-height: 36px

  .date-range, .date-single
    font-size: 13px
</style>
